import { pendingSlice } from './';

export const { setPending, resetPending } = pendingSlice.actions;
